import { Injectable, Injector } from "@angular/core";
import { ApiService, BASE_URL } from "../../services/base-service/api.service";
import { HttpClient } from "@angular/common/http";
import { HttpHeaders } from "@angular/common/http";
import { map, catchError } from 'rxjs/operators';
import { ErrorUtil } from '../../helpers/error.utils';
import { NotificationsMessages } from '../../services/shared/notifications-messages';

@Injectable()
export class HoardingService extends ApiService<any, any, any> {

    urlPath: string = 'hoardings';
    constructor(private Http: HttpClient, private Injector: Injector) {
        super(Http, Injector);
    }

    getHoardingsByContractId(id) {
        if (navigator.onLine) {
            return this.Http.get(this.baseUrl + 'hoardings/byContractId?contractId=' + id);

        }
    }

    downloadFile(fileType, data) {
        if (navigator.onLine) {
            let options = {};

            if (fileType === 'XLSX') {
                const fileUrl = this.baseUrl + 'hoardings/exportGrid/XLSX';
                options = { responseType: "arraybuffer" };
                return this.Http.post(fileUrl, data, options).pipe(map((response: any) => {
                    return response;
                }), catchError((err) => {

                    const errorObject = ErrorUtil.getErrorObject(err);
                    if (errorObject.code === 417 || errorObject.code === 412) {
                        this.notificationServcie.info(errorObject.message ? errorObject.message : NotificationsMessages.TRY_AGAIN, NotificationsMessages.INFORMATION);
                    } else {
                        this.notificationServcie.error(errorObject.message ? errorObject.message : NotificationsMessages.TECHNICAL_ISSUE, NotificationsMessages.ERROR)
                    }
                    return err;
                }));
            }
        }

    }

}